import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/core/services/local-storage.service';
import { LogService } from 'src/core/services/log.service';
import { UtilsService } from 'src/core/services/utils.service';
import { Log } from 'src/interfaces/log';

@Component({
  selector: 'app-log-list',
  templateUrl: './log-list.component.html',
  styleUrls: ['./log-list.component.scss']
})
export class LogListComponent implements OnInit {

  displayedColumns: string[] = [
    'entity_id',
    'entity',
    'log_type',
    'date_and_time'
  ];

  logsDataSource: MatTableDataSource<Log>;
  page: number = 1;
  limit: number = 10;
  totalNumberOfLogs: number = 0;


  dateRangeForm = this._formBuilder.group({
    start_date: ['', Validators.required],
    end_date: ['', Validators.required]
  })

  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private _logService: LogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _localStorageService: LocalStorageService,
    public utilService: UtilsService,
    private _formBuilder: FormBuilder,
  ) {
    const limit = this._localStorageService.get('LOGS', 'LIMIT');

    if (limit) {
      this.limit = parseInt(limit);
    }
  }

  ngOnInit(): void {

    this
      ._route
      .data
      .subscribe(data => {
        this.logsDataSource = new MatTableDataSource<Log>(data.logs.logs);
        this.page = data.logs.pageNumber;

        this.totalNumberOfLogs = this._logService.getTotalNumberOfLogs();
        this.logsDataSource.sort = this.sort;
      });

    this.dateRangeForm
      .controls['start_date']
      .valueChanges
      .subscribe(value => {
        this.selectedStartDate = value;
        if (this.selectedStartDate) this.selectedStartDate.setHours(this.selectedStartDate.getHours() + 2);
      });



    this.dateRangeForm
      .controls['end_date']
      .valueChanges
      .subscribe(value => {
        this.selectedEndDate = value;
        this.page = 1;
        // only want to make a request when both dates are selected 
        if (this.selectedStartDate && this.selectedEndDate) {


          this.selectedEndDate.setHours(this.selectedEndDate.getHours() + 24);

          this.listLogs(
            this.page,
            this.limit,
            this.utilService.bestBeforeTime(this.selectedStartDate.toISOString()),
            this.utilService.bestBeforeTime(this.selectedEndDate.toISOString())
          )
        }
      })



  }

  onPageChange(event: PageEvent) {
    // Get more orders 
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;

    this._localStorageService.store('LOGS', 'LIMIT', this.limit.toString());


    const start_date: string | null = this.selectedStartDate ? this.utilService.bestBeforeTime(this.selectedStartDate.toISOString()) : null;
    const end_date: string | null = this.selectedEndDate ? this.utilService.bestBeforeTime(this.selectedEndDate.toISOString()) : null;


    this.listLogs(
      this.page,
      this.limit,
      start_date,
      end_date
    );


    this.totalNumberOfLogs = this._logService.getTotalNumberOfLogs();
  }

  listLogs(
    page: number = 1,
    limit: number = 10,
    start_date: string | null = null,
    end_date: string | null = null
  ) {
    (async () => {
      const newLogs = await this._logService
        .getLogs(
          page,
          limit,
          "",
          start_date,
          end_date
        );
      const newData = [
        ...newLogs
      ]
      this.logsDataSource.data = newData;
      this.totalNumberOfLogs = this._logService.getTotalNumberOfLogs();
    })();
  }

  async viewLog(log: Log): Promise<void> {
    await this._logService.openLogViewDialog(log);
  }

}